import { takeEvery, call, put } from 'redux-saga/effects';
import { USERS, USER_STATUS } from '../../../constants';
import { fetchUserList, fetchUserStatus } from '../../../api';
import {
  setUsers,
  setUsersError,
  setUserStatus,
  setUserStatusError
} from '../actions';

function* makeUsersRequest() {
  try {
    const allUsers = yield call(fetchUserList);
    yield put(setUsers(allUsers));
  } catch (e) {
    yield put(setUsersError(e));
  }
}

function* makeUserStatusRequest(params) {
  try {
    const data = yield call(fetchUserStatus, params);
    yield put(setUserStatus(data));
  } catch (e) {
    yield put(setUserStatusError(e));
  }
}

export const userSagas = [
  takeEvery(USERS.LOAD_REQUEST, makeUsersRequest),
  takeEvery(USER_STATUS.LOAD_REQUEST, makeUserStatusRequest)
];



// WEBPACK FOOTER //
// ./src/modules/Users/sagas/index.js